import React, { useEffect, useState } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  CircularProgress,
  Grid,
  TextField,
} from '@mui/material';
import { useMain } from '../../hooks/useMain';

const LatestSubscriptionUpdate = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const { fetchLatestSubscriptionUpdateBranch } = useMain();

  useEffect(() => {
    const getLatestSubscriptionBranches = async () => {
      setLoading(true);
      const params = {};
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;

      try {
        const res = await fetchLatestSubscriptionUpdateBranch(params);
        if (res?.statusCode === 200) {
          setData(res.data?.branches || []);
        }
      } catch (error) {
        console.error('Error fetching latest subscription update branches', error);
      } finally {
        setLoading(false);
      }
    };

    // If only one of the two dates is filled, wait for both before calling API
    if ((startDate && !endDate) || (!startDate && endDate)) {
      return;
    }

    getLatestSubscriptionBranches();
  }, [startDate, endDate, fetchLatestSubscriptionUpdateBranch]);

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <Box>
      <Grid container spacing={2} sx={{ mb: 2 }} alignItems="center" justifyContent="space-between">
        <Grid item>
          <Typography variant="h4">Latest Subscription Update</Typography>
        </Grid>
        <Grid item container spacing={2} xs={12} sm="auto">
          <Grid item xs={6} sm={4}>
            <TextField
              label="Start Date"
              type="date"
              variant="standard"
              fullWidth
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <TextField
              label="End Date"
              type="date"
              variant="standard"
              fullWidth
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </Grid>

      <Box sx={{ overflow: 'auto', width: { xs: '280px', sm: 'auto' }, maxHeight: '500px' }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Table aria-label="latest subscription update table" sx={{ whiteSpace: 'nowrap', mt: 2 }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ color: 'white', fontWeight: '600', borderRadius: '10px 0 0 10px', background: '#6174DD', position: 'sticky', top: 0, zIndex: 1 }}>
                  Branch Name
                </TableCell>
                <TableCell sx={{ color: 'white', fontWeight: '600', background: '#6174DD', position: 'sticky', top: 0, zIndex: 1 }}>Branch Phone</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: '600', background: '#6174DD', position: 'sticky', top: 0, zIndex: 1 }}>Owner Name</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: '600', background: '#6174DD', position: 'sticky', top: 0, zIndex: 1 }}>Duration</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: '600', background: '#6174DD', position: 'sticky', top: 0, zIndex: 1 }}>Start Date</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: '600', borderRadius: '0 10px 10px 0', background: '#6174DD', position: 'sticky', top: 0, zIndex: 1 }}>
                  End Date
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <TableRow key={item._id || index}>
                    <TableCell>{item.branchName}</TableCell>
                    <TableCell>{item.branchPhone || item.phone || 'N/A'}</TableCell>
                    <TableCell>{item.ownerId?.name || 'N/A'}</TableCell>
                    <TableCell>{item.subscriptionDetails?.duration?.duration || 'N/A'}</TableCell>
                    <TableCell>{formatDate(item.subscriptionDetails?.duration?.startDate)}</TableCell>
                    <TableCell>{formatDate(item.subscriptionDetails?.duration?.endDate)}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <Typography>No records found</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        )}
      </Box>
    </Box>
  );
};

export default LatestSubscriptionUpdate;